import React from "react";
import { AdminJobPostingPageController } from "./controller";
import { AdminJobPostingPageView } from "./view";
import { styles } from "./styles";

export class AdminJobPostingPage extends React.Component {
  render() {
    const controller = new AdminJobPostingPageController(this.props);

    return (
      <AdminJobPostingPageView
        controller={controller}
        {...this.props}
        styles={styles}
      />
    );
  }
}
